export default "__VITE_ASSET__005ffd4f__"